var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.004,
    height: 17,
    viewBox: "0 0 17.004 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#707070;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-381.678-209.606a2.239,2.239,0,0,1,1.563.607c.488.463.971.934,1.429,1.426a2.314,2.314,0,0,1,0,3.141c-.059.066-.121.129-.184.192q-4.723,4.723-9.45,9.442a1.136,1.136,0,0,1-.428.261q-2.781.942-5.568,1.863a.967.967,0,0,1-.344.067.455.455,0,0,1-.392-.618c.2-.617.405-1.231.61-1.847.434-1.3.865-2.607,1.3-3.907a.948.948,0,0,1,.216-.355q4.762-4.772,9.53-9.537A2.373,2.373,0,0,1-381.678-209.606Zm-7.051,13.883,8.11-8.11-3.208-3.209-8.111,8.11Zm5.555-12.085,3.288,3.285c.188-.2.4-.4.587-.631a1.339,1.339,0,0,0-.014-1.7,19.417,19.417,0,0,0-1.527-1.521,1.2,1.2,0,0,0-1.438-.145A6.629,6.629,0,0,0-383.174-207.808Zm-10.7,14,4.216-1.4-2.808-2.808Z",
    transform: "translate(395.074 209.606)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.3243d152.svg";
export { ForwardRef as ReactComponent };